import * as React from "react";
import { PromptGeneratorContext } from "@/components/feature/promptGenerator/context";
import { type PromptGeneratorContextState } from "@/components/feature/promptGenerator/types";

interface UsePromptGeneratorContext extends PromptGeneratorContextState {
  sendPromptToChat: (prompt: string | null) => void;
  sendPromptToImprove: (prompt: string | null) => void;
}

export const usePromptGeneratorContext = (): UsePromptGeneratorContext => {
  const context = React.useContext(PromptGeneratorContext);

  if (!context) {
    throw new Error("usePromptGeneratorContext must be used within a PromptGeneratorProvider");
  }
  const { state, setState } = context;

  const sendPromptToImprove = React.useCallback(
    (prompt: string | null) => {
      setState(prev => ({
        ...prev,
        promptToImprove: prompt,
      }));
    },
    [setState],
  );

  const sendPromptToChat = React.useCallback(
    (prompt: string | null) => {
      setState(prev => ({
        ...prev,
        promptToChat: prompt,
      }));
    },
    [setState],
  );

  return {
    promptToImprove: state.promptToImprove,
    promptToChat: state.promptToChat,
    sendPromptToChat: sendPromptToChat,
    sendPromptToImprove,
  };
};
